export const NO_SEARCH_FIELD_SCHEMA = {
  id: '_noSearch',
  type: 'Bool',
  name: 'No Search',
  slug: '_noSearch',
  required: false,
};
